import { render, staticRenderFns } from "./PosReceiptTemplateBuilder.vue?vue&type=template&id=58cbccbe&scoped=true"
import script from "./PosReceiptTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./PosReceiptTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./PosReceiptTemplateBuilder.vue?vue&type=style&index=0&id=58cbccbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbccbe",
  null
  
)

export default component.exports